"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BugMovementComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const Utils_1 = require("../../../Shared/Utils");
const CHANGE_FRAME_IN = .1;
class BugMovementComponent extends gotti_1.Component {
    constructor(frames) {
        super(Constants_1.SYSTEMS.BUG_MOVEMENT_AND_ANIMATION);
        this.timeSinceLastMovementChange = 0;
        this.timeSinceFrameChange = 0;
        this.curFrame = 0;
        this.frames = [];
        this.changeMovementIn = { x: 100, y: 100 };
        this.movingDirections = { x: 1, y: 1 };
        this.changeYMovementInDistance = 0;
        this.frames = frames;
        this.movingDirections = { x: Math.random() > .5 ? 1 : -1, y: Math.random() > .5 ? 1 : -1 };
    }
    resetMovement(axis) {
        if (!this.gameObject || !this.gameObject.sprite)
            return;
        const cur = this.gameObject.sprite[axis];
        if (cur >= 700 && cur <= 1200) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(50, 350);
            this.movingDirections[axis] = this.movingDirections[axis] * -1;
            return;
        }
        if (cur <= 200) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(1000, 1500);
            this.movingDirections[axis] = 1;
        }
        else if (cur < 300) {
            this.movingDirections[axis] = 1;
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(900, 1400);
        }
        else if (cur < 400) {
            this.movingDirections[axis] = 1;
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(800, 1300);
            this.movingDirections[axis] = 1;
        }
        else if (cur < 400) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(700, 1200);
            this.movingDirections[axis] = 1;
        }
        else if (cur < 500) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(600, 1000);
            this.movingDirections[axis] = 1;
        }
        else if (cur < 600) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(500, 800);
            this.movingDirections[axis] = 1;
        }
        else if (cur < 700) {
            this.movingDirections[axis] = 1;
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(400, 700);
        }
        else if (cur >= 2000) {
            this.movingDirections[axis] = -1;
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(1000, 1500);
        }
        else if (cur > 1900) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(950, 1450);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1800) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(900, 1400);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1700) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(800, 1300);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1600) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(700, 1200);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1500) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(600, 1000);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1400) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(500, 800);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1300) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(450, 750);
            this.movingDirections[axis] = -1;
        }
        else if (cur > 1200) {
            this.changeMovementIn[axis] = Utils_1.getRandomNumber(400, 700);
            this.movingDirections[axis] = -1;
        }
    }
    incrFrame() {
        if (++this.curFrame >= this.frames.length) {
            this.curFrame = 0;
        }
        if (this.bug && this.bug.gameObject) {
            this.bug.gameObject.sprite.texture = this.frames[this.curFrame];
        }
    }
    getNewDegreeDirection() {
        const nextAngle = Utils_1.getRandomNumber(0, 360);
        const p = this.position.getPosition();
        if (p.x > 1500 && nextAngle > 0 && nextAngle < 180) {
            return this.getNewDegreeDirection();
        }
    }
    isMovingRight() {
        return true;
    }
    updateMovement(delta) {
        const gameObject = this.bug.gameObject;
        if (!gameObject)
            return;
        this.timeSinceLastMovementChange += delta;
        this.timeSinceFrameChange += delta;
        if (this.timeSinceFrameChange > CHANGE_FRAME_IN) {
            this.incrFrame();
            this.timeSinceFrameChange = 0;
        }
        let deltaX = 50 * delta * this.movingDirections.x;
        let deltaY = 50 * delta * this.movingDirections.y;
        const { x, y } = this.position.setPositionByDeltas(deltaX, deltaY);
        this.changeMovementIn.x -= Math.abs(deltaX);
        if (this.changeMovementIn.x <= 0) {
            this.resetMovement('x');
        }
        this.changeMovementIn.y -= Math.abs(deltaY);
        if (this.changeMovementIn.y <= 0) {
            this.resetMovement('y');
        }
        this.gameObject.sprite.scale.x = this.movingDirections.x;
    }
    onAdded(entity) {
        this.bug = entity;
        this.position = entity.getComponent(Constants_1.SYSTEMS.POSITION);
        this.gameObject = entity.gameObject;
        if (!this.position)
            throw new Error(`Expected position`);
    }
}
exports.BugMovementComponent = BugMovementComponent;
//# sourceMappingURL=module.js.map